import Plain from "@/types/Plain";
import {isNullOrUndefined} from "@/utils/utils";

function outArray(value: Array<number | boolean | string | Plain | null >) {
    return value.length && value.join(',') || undefined;
}

function isObject(value: number | string | Plain | undefined | boolean | null) {
    return typeof value === 'object' && value !== null;
}

function outObject(value: number | string | Plain | undefined | boolean | null) {
    return JSON.stringify(value);
}

export default function mountQuery(query?: Plain) {
    if (!query) return ''
    const queryParams = []
    for (const p in query) {
        const value = query[p];
        const strVal = Array.isArray(value) ? outArray(value) : isObject(value)? outObject(value) : value
        if (!isNullOrUndefined(strVal)) {
            queryParams.push(`${p}=${strVal}`)
        }
    }
    if (!queryParams.length) return ''
    return '?' + queryParams.join('&')
}